import React, { createContext, useContext, useState, useCallback } from 'react';
import { FEATURE_FLAGS } from '../config/featureFlags';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    // When the language switcher is disabled, always use English regardless
    // of any previously stored preference.
    if (!FEATURE_FLAGS.LANGUAGE_SWITCHER) return 'en';
    return localStorage.getItem('fc_lang') || 'en';
  });

  const setLang = useCallback((l) => {
    if (!FEATURE_FLAGS.LANGUAGE_SWITCHER) return; // no-op when feature is off
    setLangState(l);
    localStorage.setItem('fc_lang', l);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
};

export default LanguageContext;
